import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../static/utils/dialog';
// import VueContextMenu from 'vue-contextmenu'

Vue.config.productionTip = false
Vue.use(ElementUI);
// Vue.use(VueContextMenu);

var debug = true
window.log = debug ? console.log.bind(console, '*** debug ***'): function () {}

new Vue({
    el: '#app',
    router: router,
    components: { App },
    template: '<App/>',
    /* 这句非常重要，否则预渲染将不会启动 */
    mounted () {
        document.dispatchEvent(new Event('render-event'))
    }
})



// WEBPACK FOOTER //
// ./src/main.js